import { useReportCanonicalRumViewName } from '@ctw/shared/context/telemetry/use-rum-view-name';
import { ZapProvider } from '@ctw/shared/context/zap-context';
import { ZuiProvider } from '@ctw/shared/context/zui-provider';
import { trimStart } from 'lodash-es';
import { useMemo } from 'react';
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router';
import ZAPV2 from './ZAP-v2';

const RouteDefinitions = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useReportCanonicalRumViewName(location.pathname);

  const navigateBasePath = useMemo(() => {
    const pathSegments = trimStart(location.pathname, '/').split('/');
    const firstSegment = pathSegments[0];

    if (firstSegment === 'zap-v2') {
      return '/zap-v2';
    }

    return '/zap';
  }, [location.pathname]);

  return (
    <ZuiProvider
      service="smart-on-fhir"
      navigate={navigate}
      navigateBasePath={navigateBasePath}
      navigatePersistentQueryParams={['ehr']}
      pathname={useLocation}
    >
      <ZapProvider>
        <Routes>
          <Route path="/zap-v2/*" element={<ZAPV2 />} />
        </Routes>
      </ZapProvider>
    </ZuiProvider>
  );
};

export function App() {
  return (
    <BrowserRouter>
      <RouteDefinitions />
    </BrowserRouter>
  );
}
